import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { LoadingTopbar } from './LoadingTopbar';
const FullPageLoader = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LoadingTopbar />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<div className="fixed inset-0 flex items-center justify-center"><Image src="/images/orsay-mark.svg" alt="Loading" width={80} height={80} className="animate-bounce [animation-duration:1.4s]" priority={true} /></div></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export { FullPageLoader };